import { BASE_URL } from "@/constants/config";

export const CAMPAIGN_REPORTS_ENDPOINTS = {
  reports: `${BASE_URL}api/campaign_reports/`,
  collected_premiums_n_1: `${BASE_URL}api/campaign_reports/collected_premiums_n_1/`,
  estimates_n_1: `${BASE_URL}api/campaign_reports/estimates_n_1/`,
  statistiques: `${BASE_URL}api/campaign_reports/statistiques/`,
  control: `${BASE_URL}api/campaign_reports/control/`,
}
